import React from "react";

import WarningIcon from "@mui/icons-material/Warning";
import { Box, Button, Modal, Typography } from "@mui/material";
import { makeStyles, withStyles } from "tss-react/mui";

import { Recipe } from "@/gql/graphql";
import { colors } from "@/theme/overrides/colors";

type ModalProps = {
  recipeId: string;
  visibility: boolean;
  onClose: () => void;
  handleCancel: (id: Recipe["id"]) => Promise<void>;
};
const useStyles = makeStyles()((theme) => ({
  root: {
    overflowY: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(4),
  },
  modalBody: {
    display: "flex",
    flexDirection: "column",
    margin: theme.spacing(24, 24),
    backgroundColor: colors.white,
    overflowY: "auto",
    width: "470px",
  },
  content: {
    padding: "40px",
  },
  header: {
    fontSize: "32px",
    fontWeight: 700,
  },
  message: {
    fontSize: "14px",
    fontWeight: 400,
    marginBottom: "20px",
    textAlign: "center",
    color: colors.grey,
  },
}));

const StyledCancelButton = withStyles(Button, {
  root: {
    color: colors.primary,
    marginRight: 8,
    "&:hover": {
      color: "#FF6262",
    },
  },
});

const StyledWarningIcon = withStyles(WarningIcon, {
  root: {
    color: "#FFB160",
    height: 78,
    width: 78,
  },
});

const CancelDuplicateRecipeModal: React.FC<ModalProps> = ({
  visibility,
  onClose,
  handleCancel,
  recipeId,
}) => {
  const { classes } = useStyles();
  return (
    <>
      <Modal open={visibility} onClose={onClose} className={classes.root}>
        <Box className={classes.modalBody}>
          <div>
            <Box className={classes.content}>
              <Box
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
              >
                <StyledWarningIcon />
                <Typography className={classes.header}>
                  Cancel duplicate recipe?
                </Typography>
              </Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <Typography className={classes.message}>
                  Cancelling will not save any existing data from this duplicate
                  recipe
                </Typography>
              </Box>
              <Box display="flex" justifyContent="center" alignItems="center">
                <StyledCancelButton
                  variant="text"
                  onClick={() => handleCancel(recipeId)}
                >
                  Yes, cancel recipe
                </StyledCancelButton>
                <Button color="primary" onClick={onClose}>
                  Continue Working
                </Button>
              </Box>
            </Box>
          </div>
        </Box>
      </Modal>
    </>
  );
};

export default CancelDuplicateRecipeModal;
